/* @flow */
import * as React from 'react';

import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ConfirmDialog from 'components/ConfirmDialog';

function otherMemberName(chat: Chat): ?string {
  const otherMember = chat.getOtherMember();
  if (otherMember) {
    return otherMember.name;
  }
  const otherChatMembers = chat.getOtherChatMembers();
  const firstMember = otherChatMembers && otherChatMembers[0];
  if (firstMember) {
    return firstMember.getName();
  }

  return null;
}

class DisableRepliesConfirmationDialog extends React.Component<{
  chat: Chat,
  onRequestHide?: () => any, // injected prop, not actually optional
}> {
  render() {
    const { chat } = this.props;

    const subject = (() => {
      if (chat.isGroupChat()) {
        return 'Participants';
      }
      const name = otherMemberName(chat);
      if (name) {
        return name;
      }
      return 'Participant';
    })();

    const subtext = `${subject} won’t be able to reply to any messages in this conversation.`;
    return (
      <ConfirmDialog
        eventScreenName="DisableRepliesConfirmationDialog"
        title="Turn off replies?"
        subtext={subtext}
        actionButtonText="Turn off"
        cancelButtonText="Cancel"
        onConfirm={() => ChatActions.disableReplies(chat)}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}
export default DisableRepliesConfirmationDialog;
